var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressBookContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.073,
    height: 16.957,
    viewBox: "0 0 15.073 16.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4213408_address_book_contact_contacts_human_icon",
    "data-name": "4213408_address_book_contact_contacts_human_icon",
    transform: "translate(-8 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20270",
    "data-name": "Path 20270",
    d: "M51.778,30.1a2.678,2.678,0,1,0,2.678,2.678A2.676,2.676,0,0,0,51.778,30.1Zm0,4.28a1.6,1.6,0,1,1,1.6-1.6A1.605,1.605,0,0,1,51.778,34.38Z",
    transform: "translate(-35.569 -25.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20271",
    "data-name": "Path 20271",
    d: "M12.576,2.077H22v14.8H9.077V2.077h1.077V15.535H11.23V1H8V17.957H23.073V1h-10.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20272",
    "data-name": "Path 20272",
    d: "M51.5,78.619l.565.915a3.592,3.592,0,0,1,1.79-.471,3.726,3.726,0,0,1,1.79.458l.565-.915A4.906,4.906,0,0,0,53.855,78,4.771,4.771,0,0,0,51.5,78.619Z",
    transform: "translate(-37.646 -66.637)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBookContactIcon);
export default __webpack_public_path__ + "static/media/address_book_contact_icon.288848bd7be58c7f2384c4aa54bffc52.svg";
export { ForwardRef as ReactComponent };